import React from 'react';
import Header from './components/layout/Header';
import Hero from './components/home/Hero';
import AboutContent from './components/about/AboutContent';
import ExistingCustomers from './components/customers/ExistingCustomers';
import ServicesPage from './pages/ServicesPage';
import IndustriesGrid from './components/industries/IndustriesGrid';
import WhyUsContent from './components/whyus/WhyUsContent';
import ContactInfo from './components/contact/ContactInfo';
import Footer from './components/layout/Footer';
import './App.css';

function App() {
    return ( <
        div className = "App" >
        <
        Header / >
        <
        main >
        <
        section id = "home"
        className = "section" >
        <
        Hero / >
        <
        /section>

        <
        section id = "about"
        className = "section" >
        <
        AboutContent / >
        <
        /section>

        { /* Customers Section - Between About and Services */ } <
        section id = "customers"
        className = "section" >
        <
        ExistingCustomers / >
        <
        /section>

        <
        section id = "services"
        className = "section" >
        <
        ServicesPage / >
        <
        /section>

        <
        section id = "industries"
        className = "section" >
        <
        IndustriesGrid / >
        <
        /section>

        <
        section id = "why-us"
        className = "section" >
        <
        WhyUsContent / >
        <
        /section>

        <
        section id = "contact"
        className = "section" >
        <
        ContactInfo / >
        <
        /section> <
        /main> <
        Footer / >
        <
        /div>
    );
}

export default App;